import './components/editor.js';
import './components/tooltip.js';
import './components/deadlines.js';
import './components/select.js';
import './components/deadline-calendar.js';
import './components/task.js';
import './libs/sortable.lib.js';
